<div class="container-fluid">
  <div class="row fun__main">
    <div class="fun__mfa">
      <div class="fun_spacing"></div>
      <h1 class="fun__mfa__title">Forgot username</h1>
      <!-- Form fields for user input -->
      <form [formGroup]="forgotUserNameForm" class="fun__form fun__form--inverse js-form" *ngIf="isSuccessful">
        <div>
          <div class="fun__form__row">
            <label class="fun__form__input-label fun__form__item">
              <div class="fun__form__label-text">
                <span>Email address: <span aria-hidden="true">*</span></span>
              </div>
              <div class="fun__form__icon" role="img" aria-hidden="true"></div>
              <input
                type="text"
                class="fun__form__input js-form-input is-required"
                formControlName="emailAddress"
                (blur)="validateInput($event)"
                required
                aria-required="true"
                [attr.aria-label]="isValid ? 'Email address input' : 'Please enter a valid email address'"
              />
            </label>
          </div>
          <div class="fun__form__error-message" *ngIf="!isValid" role="alert">Please enter your email address</div>
          <div class="recaptcha-container" id="recaptcha-container"></div>
          <div class="fun__form__error-message" *ngIf="isRecaptchaSel" role="alert">
            Please verify you're not a robot
          </div>
          <div class="fun__form__row">
            <button
              type="button"
              (click)="onSubmit()"
              class="fun__button fun__button--arrow fun__button--secondary fun__button--small js-form-submit"
            >
              <span>Email my username</span>
            </button>
          </div>
          <div class="fun__form__row">
            <a role="link" href="/login" class="link fun-signin">Back to Log In</a>
          </div>
        </div>
      </form>

      <div class="fun__form fun__form--inverse js-form" *ngIf="!isSuccessful">
        <div>
          <div class="fun__mfa__subtitle-text">Your username has been sent to your email address.</div>
          <div class="fun__mfa__subtitle-textdesc">Please use your username to Log In again.</div>
          <div class="fun__form__row">
            <button
              type="button"
              (click)="onContinue()"
              class="fun__button fun__button--arrow fun__button--secondary fun__button--small js-form-submit"
            >
              <span>Continue</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
